module.exports = __webpack_public_path__ + "img/mIconDbSchema.ce632ac9.svg";